module.exports = __webpack_public_path__ + "img/keshavarzi.7891f24d.png";